/* Shop menu fly-outs (Products & Collections, David, Oct 30 2026). Data and styles: snippets/mm-shop-fly.liquid.
   Computers: hover a Shop row (or click its ">") for its types beside the dropdown. Phone menu: tap ">" to list them under the row.
   Only one fly-out is open at a time. Other Invertebrates is greyed out and not clickable ("Coming soon").
   Horizon re-draws the header after load, so the rows are dressed again whenever the header changes (safe to repeat). */
(function () {
  var el = document.getElementById("mm-shop-fly-data"), D;
  if (!el) return;
  try { D = JSON.parse(el.textContent); } catch (e) { return; }
  var MAP = D.map || {}, SOON = D.soon || [], EXTRA = D.extra || {};   // EXTRA: page links added after a fly-out's types (Partners, Nov 3 2026)
  var ROWS = "#header-component header-menu .menu-list__submenu a.mega-menu__link, " +
    "#header-component .menu-drawer .menu-drawer__menu--childlist a.menu-drawer__menu-item--child";
  var open = null;

  function path(a) { try { return new URL(a.getAttribute("href"), location.href).pathname.replace(/\/$/, ""); } catch (e) { return ""; } }
  function inDrawer(n) { return !!n.closest(".menu-drawer"); }

  function close(focusBtn) {
    if (!open) return;
    var o = open; open = null;
    o.fly.hidden = true; o.btn.setAttribute("aria-expanded", "false"); o.host.classList.remove("mm-sf-open");
    if (focusBtn) o.btn.focus();
  }
  function show(o, kb) {
    if (open && open.fly === o.fly) return;
    close(false);
    o.fly.hidden = false; o.btn.setAttribute("aria-expanded", "true"); o.host.classList.add("mm-sf-open");
    o.fly.classList.remove("mm-fly--left");
    if (!inDrawer(o.host)) {
      var r = o.fly.getBoundingClientRect();
      if (r.right > (window.innerWidth || document.documentElement.clientWidth) - 4) o.fly.classList.add("mm-fly--left");
    }
    open = o;
    if (kb) { var f = o.fly.querySelector("a"); if (f) f.focus(); }
  }

  function dress(a) {
    var host = a.parentNode, p = path(a);
    if (!host || a.classList.contains("mm-sf-soon") || host.querySelector(":scope > .mm-sf-btn")) return;
    if (SOON.indexOf(p) > -1) {
      a.classList.add("mm-sf-soon"); a.setAttribute("aria-disabled", "true"); a.setAttribute("tabindex", "-1"); a.title = "Coming soon";
      return;
    }
    var gs = MAP[p];
    if (!gs || gs.length < 2) return;
    var name = (a.textContent || "").trim();
    host.classList.add("mm-sf-host");
    var btn = document.createElement("button");
    btn.type = "button"; btn.className = "mm-sf-btn"; btn.textContent = ">";
    btn.setAttribute("aria-haspopup", "menu"); btn.setAttribute("aria-expanded", "false");
    btn.setAttribute("aria-label", name + " categories");
    var fly = document.createElement("ul");
    fly.className = "mm-fly mm-sf-fly"; fly.setAttribute("role", "menu"); fly.setAttribute("aria-label", name); fly.hidden = true;
    gs.forEach(function (g) {
      var li = document.createElement("li"); li.setAttribute("role", "none");
      var l = document.createElement("a"); l.setAttribute("role", "menuitem");
      l.href = p + "?mm_g=" + g[0]; l.textContent = g[1];
      li.appendChild(l); fly.appendChild(li);
    });
    (EXTRA[p] || []).forEach(function (x) {
      var li = document.createElement("li"); li.setAttribute("role", "none");
      var l = document.createElement("a"); l.setAttribute("role", "menuitem");
      l.href = x[0]; l.textContent = x[1];
      li.appendChild(l); fly.appendChild(li);
    });
    a.insertAdjacentElement("afterend", btn);
    btn.insertAdjacentElement("afterend", fly);
    var o = { host: host, btn: btn, fly: fly };
    btn.addEventListener("click", function (e) {
      e.preventDefault();
      if (!inDrawer(host)) e.stopPropagation();   // phone menu: let mm-oct15-nav.js re-fit the Shop popup
      open && open.fly === fly ? close(false) : show(o, e.detail === 0);
    });
    btn.addEventListener("keydown", function (e) { if (e.key === "ArrowRight") { e.preventDefault(); show(o, true); } });
    fly.addEventListener("keydown", function (e) {
      var ls = [].slice.call(fly.querySelectorAll("a")), i = ls.indexOf(document.activeElement);
      if (e.key === "ArrowDown") { e.preventDefault(); (ls[i + 1] || ls[0]).focus(); }
      else if (e.key === "ArrowUp") { e.preventDefault(); (ls[i - 1] || ls[ls.length - 1]).focus(); }
      else if (e.key === "Escape" || e.key === "ArrowLeft") { e.preventDefault(); e.stopPropagation(); close(true); }
    });
    if (!inDrawer(host)) {
      host.addEventListener("mouseenter", function () { show(o, false); });
      host.addEventListener("mouseleave", function () { if (open && open.fly === fly) close(false); });
    }
  }

  function scan() { document.querySelectorAll(ROWS).forEach(dress); }
  // a "Coming soon" row does nothing when clicked
  document.addEventListener("click", function (e) {
    var s = e.target && e.target.closest ? e.target.closest(".mm-sf-soon") : null;
    if (s) { e.preventDefault(); e.stopPropagation(); }
  }, true);
  document.addEventListener("pointerdown", function (e) { if (open && !open.host.contains(e.target)) close(false); }, true);
  document.addEventListener("keydown", function (e) { if (e.key === "Escape" && open) close(true); });

  scan();
  var hc = document.getElementById("header-component");
  if (hc && "MutationObserver" in window) {
    var t = 0;
    new MutationObserver(function () { clearTimeout(t); t = setTimeout(scan, 60); }).observe(hc, { childList: true, subtree: true });
  }
})();
